module.exports = __webpack_public_path__ + "static/pic12.369e0fac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic12.jpg
// module id = 535
// module chunks = 35783957827783